<style>
.map {
  width: 100%;
  height: 450px;
}
</style>

<template>
  <div>
    <baidu-map class="map" :center="centerPoint" :zoom="15" :scroll-wheel-zoom="true" :min-zoom="5" :max-zoom="16">
      <bm-marker :position="centerPoint" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
    </baidu-map>
  </div>
</template>

<script>
export default {
  name: 'bmap',
  props: {
    centerPoint: {
      required: true
    }
  }
}
</script>
